<script lang="ts" setup>

const props = defineProps<{
  anchors: { href: string, label?: string }[],
  container?: string | HTMLElement | Window,
  offset?: number,
  bound?: number,
  direction?: 'h' | 'v'
  path?: string
}>()
const emit = defineEmits<{ (e: 'change', hash: string): void }>()

const hash = ref('')

// 默认重新定位到hash设定的位置
const handle = async (hash) => {
  if (!props.path || location.pathname === props.path) {
    if (hash !== location.hash) {
      location.hash = hash
    } else {
      checkHashAndScroll()
    }
    emit('change', hash)
  } else {
    location.href = `${props.path}${hash}`
  }
}

const behavior = ref('scroll')

const getContainer = () => (typeof props.container === 'string' ? document.querySelector(props.container) : props.container) ?? document.body

// hash变化监听
function checkHashAndScroll() {
  const container = getContainer()
  hash.value = location.hash
  const id = location.hash.substring(1)
  // console.log({ id })
  if (id) {
    const targetElement = document.getElementById(id)
    if (targetElement) {
      const offset = props.offset ?? 0
      const elementPosition = targetElement.offsetTop - offset
      container.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      })
      behavior.value = 'hash'
      setTimeout(() => {
        behavior.value = 'scroll'
      }, 500)
    }
  } else {
    // container.scrollTo({
    //   top: 0
    // })
  }
}

// 滚动监听
const scrollAnchor = useDebounceFn((e: Event) => {
  // 先按视口位置计算
  const base = window.innerHeight / 2
  let delta = Infinity
  let anchor
  props.anchors.forEach(v => {
    const id = v.href.substring(1)
    const el = document.getElementById(id)
    if (el) {
      const rect = el.getClientRects()[0]
      const { top, height } = rect
      if (Math.abs((top + height / 2) - base) < delta) {
        delta = Math.abs((top + height / 2) - base)
        // console.log(delta, v.href)
        anchor = v.href
      }
    }
  })
  hash.value = anchor
}, 300)

onMounted(() => {
  // 初始化
  requestAnimationFrame(() => {
    checkHashAndScroll()
    window.addEventListener('hashchange', checkHashAndScroll)
    getContainer().addEventListener('scroll', scrollAnchor)
  })
})

onUnmounted(() => {
  window.removeEventListener('hashchange', checkHashAndScroll)
  getContainer().removeEventListener('scroll', scrollAnchor)
})

</script>

<template>
  <div>
    <a v-for="v in anchors" :href="v.href" @click.prevent="handle(v.href)">
      <slot v-bind="{ item: v, active: v.href === hash }"></slot>
    </a>
  </div>
</template>

<style lang="scss" scoped></style>
